import React, { Component } from "react";
import { connect, useDispatch } from "react-redux";
import { Icon, Table, Spin } from "antd";
import { Button, Modal } from "../../../../helpers/commonUi";
import { AppState } from "../../../../stateManager/store";
import { ReactComponent as TableEdit } from "../../../../assets/svg/editIcon.svg";
import { ReactComponent as Delete } from "../../../../assets/svg/delete.svg";
import { Http } from "../../../../helpers/axois";
import { ReactComponent as FunctionIcon } from "../../../../assets/svg/functionIllustration.svg";
import style from "./list.module.sass";
import NoData from "../../NoData";
import Functions from "./Functions";
import { pushToast } from "../../../../stateManager/store/toast/actions";
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { ReactComponent as MPFuncIcon } from '../../../../assets/svg/MarketplaceFunctions/Shop_light.svg'
import moment from "moment";

import { ImportFunction } from "../../../marketplace/functions/functionImport/importFunction"
import { updateFormVersion } from "../../../../stateManager/store/apps/actions";
import { ReactComponent as PublicAccessIcon } from '../../../../assets/svg/public_access.svg'
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface Props {
  match?: any;
  app?: any;
  history?: any;
  appVersion?: { currentVersion: boolean; versionId: string };
  pushToast: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
}

interface State {
  visible: boolean;
  editInitialData?: any;
  funcList?: any[];
  editable: boolean;
  editvisible?: boolean;
  loading?: boolean;
  deleteData: any;
  deleteVisible: boolean;
  displayName?: string;
  functionName?: string;
  language?:string;
  mode?:string;
  saveFnModalVisibility:boolean;
  functionId: string;
  cacheable?: boolean;
  exposeEndpoint?: boolean;
  allowedMethods?: string[];
  apiKeyAuth?: boolean;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

class FunctionList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editable: false,
      funcList: [],
      editvisible: false,
      loading: false,
      deleteVisible: false,
      deleteData: {},
      displayName: "",
      functionName:"",
      language:"",
      mode:"",
      saveFnModalVisibility: false,
      functionId:"",
      cacheable: false,
      exposeEndpoint: false,
      allowedMethods: [],
      apiKeyAuth: true,
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef()
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.versionUpdate(this.props);
  }

  componentWillReceiveProps(props: Props) {
    if (props.appVersion !== this.props.appVersion) {
      this.versionUpdate(props);
    }
  }

  versionUpdate(props: Props) {
    const version = props.appVersion;
    if (version) {
      this.getFunctions(props);
    }
  }

  getFunctions(props: Props) {
    const version = props.appVersion && props.appVersion.versionId;
    const appId = this.props.match.params.appId;
    this.state.searchRef.current?.clearSearch()
    Http.get(`/apps/${appId}/functions?versionId=${version}`).subscribe((serviceRes: any) => {
      this.setState({
        funcList: serviceRes,
        filteredData: serviceRes,
        loading: false,
      });
    }, (err) => {
      if (err !== 'Forbidden') {
        this.setState({
          funcList: [],
          filteredData: [],
          loading: false
        })
        this.props.pushToast(
          { type: 'error', message: (err && err.message) ? err.message : "Form Getting failed" }
        )
      }
    });
  }

  deleteFunctions(funcId: string) {
    const appId = this.props.match.params.appId;
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    this.setState({
      loading: true,
    });
    Http.delete(`/functions/${funcId}?appId=${appId}&versionId=${versionId}`).subscribe(
      (res) => {
        this.props.pushToast({ type: "success", message: "Function deleted successfully" });
        this.getFunctions(this.props);
      },
      (err) => {
        this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Function deletion failed" });
        this.setState({
          loading: false,
        });
      }
    );
  }

  handleUpdateList = (list: any) => {
    this.setState({ funcList: list });
  };

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (prevState !== this.state) {
      const exposeEle = document.querySelectorAll('.exposed_func');
      if (exposeEle.length) {
        const expose_tr: HTMLTableRowElement | null = exposeEle[exposeEle.length - 1].closest('tr');
        if(expose_tr) {
          const prev_tr = document.querySelector(".expose_func_end_row");
          prev_tr && prev_tr.classList.remove("expose_func_end_row");
          expose_tr.classList.add('expose_func_end_row');
        }
      }
    }
  }

  render() {
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
    const canEdit = currentVersion && (this.props.orgPermissions.includes('func.Edit') || this.props.appPermissions.includes('func.Edit'))
    const canCreate = currentVersion && (this.props.orgPermissions.includes('func.Create') || this.props.appPermissions.includes('func.Create'))
    const canDelete = currentVersion && (this.props.orgPermissions.includes('func.Delete') || this.props.appPermissions.includes('func.Delete'))
    const canView = this.props.orgPermissions.includes('func.View') || this.props.appPermissions.includes('func.View')

    const columns: any = [
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (text: any, record: any) => {
          const isMarketplaceFunction = record.marketplaceId;
          const formattedValue = highlightMatch(text, this.state.searchValue)
          return (
            <span style={{ display: "flex", alignItems: "end" }} title={text} className={`${record.exposeEndpoint ? "exposed_func": ""}`}>
              <div className="flex flex-col gap-2">
                <span style={{ overflowWrap:"anywhere" }} className="flex gap-2 items-center">
                  <span>{formattedValue}</span>
                  {record.exposeEndpoint ? <PublicAccessIcon></PublicAccessIcon> : null}
                </span>
                {record.exposeEndpoint ? <div className="flex gap-2">{record.allowedMethods.map((method: string)=> {return <span className="function_allow_mthds uppercase rounded-md">{method}</span>})}</div> : null}
              </div>
              {isMarketplaceFunction ?
                <span className={style.marketplaceBadge}>
                  <MPFuncIcon height={19} width={19} />
                </span>
                : null
              }
            </span>
          )
        },
      },
      {
        title: "Name(Identifier)",
        dataIndex: "name",
        key: "name",
        render: (value: string)=>{
          const formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Mode",
        dataIndex: "mode",
        key: "mode",
        render: (value: string)=>{
          const formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        },
        width: 100
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
        render: (value: string)=>{
          const formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        },
        width: 200
      },
      {
        title: "Created At",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 400,
        render: (text: any, record: any) => {
          const { marketplaceInstalledVersion, marketplaceLatestVersion, marketplaceId } = record
          const isUpdateAvailable = marketplaceId && marketplaceLatestVersion !== marketplaceInstalledVersion
          let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
          formattedValue = highlightMatch(formattedValue, this.state.searchValue)
          return (
            <span>
              <span>{formattedValue}</span>
              {isUpdateAvailable ?
                <button className={style.updateButton}>Update Available</button>
                : null}
            </span>
          )
        },
      }
    ];

    if (currentVersion) {
      columns.push(
        {
          title: "Action",
          key: "action",
          render: (_text: any, record: any) => {
            const { displayName, name, lang, mode, id, cacheable, exposeEndpoint, allowedMethods, apiKeyAuth } = record;
            return (
              <span>
                <span
                  data-test-id="action_edit"
                  title="Edit"
                  className="action-icon edit-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                      this.props.pushToast({
                        type: 'error',
                        message: 'Cannot modify a previous app version'
                      })
                      return
                    }
                    if (canEdit) {
                      this.setState({
                        editvisible: true,
                        editInitialData: record,
                        editable: true,
                        displayName,
                        functionName: name,
                        language: lang,
                        mode: mode,
                        functionId: id,
                        cacheable: cacheable,
                        exposeEndpoint,
                        allowedMethods,
                        apiKeyAuth
                      });
                    } else {
                      this.props.pushToast({
                        type: 'error',
                        message: 'You are not authorized to edit this function'
                      })
                    }
                  }}
                >
                  <TableEdit height="15px" width="15px" />
                </span>
                {this.state.funcList!.length >= 1 && (
                  <span
                    data-test-id="action_delete"
                    className="action-icon delete-icon"
                    title="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                        this.props.pushToast({
                          type: 'error',
                          message: 'Cannot modify a previous app version'
                        })
                        return
                      }
                      if (canDelete) {
                        this.setState({
                          deleteData: record,
                          deleteVisible: true,
                        });
                      } else {
                        this.props.pushToast({
                          type: 'error',
                          message: 'You are not authorized to delete this function'
                        })
                      }
                    }}
                  >
                    <Delete />
                  </span>
                )}
              </span>
            )
          },
        }
      )
    }

    const appId = this.props.match.params.appId;
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    return (
      canView ?
        <div className="viewWrapper">
          {!this.state.loading && this.state.funcList && this.state.funcList.length > 0 ? (
            <div className={"row " + style.data}>
              <div className={style.header}>
                <div className={style.first}>
                  <h4>Functions</h4>
                  <h5>View, edit or create a new function</h5>
                </div>
                <div className="flex items-center">
                  <SearchBar
                    ref={this.state.searchRef}
                    data={this.state.funcList}
                    columns={columns}
                    onFilter={(filteredData ) => {
                      this.setState({
                        filteredData: filteredData,
                      })
                    }}
                    onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                  />
                  <ImportFunction funcList={this.state.funcList} handleUpdateList={this.handleUpdateList} />
                  {canCreate && (
                    <Button dataTestId="create_function" size="small" onClick={() => this.setState({ visible: true })}>
                      CREATE FUNCTION
                    </Button>
                  )}
                </div>
              </div>
              <div className={style.content}>
                <Table
                  pagination={false}
                  // rowSelection={{
                  //     type: 'checkbox',
                  //     onChange: (selectedRowKeys, selectedRows) => {
                  //     }
                  // }}
                  scroll={{ y: "calc(100vh - 240px)" }}
                  columns={columns}
                  onRow={(record: any, rowIndex: any) => {
                    return {
                      'data-test-id': 'function_table_row_' + record.key,
                      onClick: (event: any) => {
                        const tag: any = event.target;
                        if (tag.id !== "delete") {
                          this.props.history.push("" + this.props.match.url + "/" + record.id + "/create");
                        }
                      },
                    };
                  }}
                  className={"override-table-container func_tble_container"}
                  dataSource={this.state.filteredData!.map((res, key) => {
                    return { ...res, key: key };
                  })}
                />
              </div>
            </div>
          ) : this.state.loading ? (
            <div className={style.loadingSpinner}>
              <Spin indicator={antIcon} style={{ color: '#15808C' }} />
            </div>
          ) : (
            <div>
              <ImportFunction funcList={this.state.funcList} handleUpdateList={this.handleUpdateList} />
              <NoData
                svg={FunctionIcon}
                header="Create Functions"
                content="Create Functions for your apps"
                // buttonText='Create new version'
                buttonCallback={() => (canCreate ? this.setState({ visible: true }) : this.props.pushToast({
                  type: 'error',
                  message: 'You are not authorized to create services'
                }))}
              />
            </div>
          )}

          <FunctionModal
            visible={this.state.visible}
            displayName={this.state.displayName}
            setDisplayName={(data:string) => this.setState({ displayName: data })}
            functionName={this.state.functionName}
            setFunctionName={(data:string) => this.setState({ functionName: data })}
            language={this.state.language}
            setLanguage={(data:string) => this.setState({ language: data })}
            mode={this.state.mode}
            setMode={(data: string) => this.setState({ mode: data })}
            saveFnModalVisibility={this.state.saveFnModalVisibility}
            setSaveFnModalVisibility={(visibility: boolean) => this.setState({ saveFnModalVisibility: visibility })}
            functionId={this.state.functionId}
            getFunction={() => this.getFunctions(this.props)}
            appId={appId}
            versionId={versionId}
            setvisible={(status) => this.setState({ visible: status })}
            cacheable={this.state.cacheable}
            setCacheable={(cacheable:boolean) => this.setState({ cacheable: cacheable })}
            setExposeEndpoint={(exposeEndpoint:boolean) => this.setState({ exposeEndpoint: exposeEndpoint})}
            exposeEndpoint = {this.state.exposeEndpoint}
            allowedMethods={this.state.allowedMethods}
            setAllowedMethods={(allowedMethods: string[]) => this.setState({ allowedMethods: allowedMethods})}
            apiKeyAuth={this.state.apiKeyAuth}
            setApiKeyAuth={(apiKeyAuth: boolean) => this.setState({ apiKeyAuth: apiKeyAuth})}
          ></FunctionModal>
          {this.state.editvisible && (
            <FunctionModal
              displayName={this.state.displayName}
              setDisplayName={(data:any) => this.setState({ displayName: data })}
              functionName={this.state.functionName}
              setFunctionName={(data:any) => this.setState({ functionName: data })}
              language={this.state.language}
              setLanguage={(data: string) => this.setState({ language: data })}
              mode={this.state.mode}
              setMode={(data: string) => this.setState({ mode: data })}
              saveFnModalVisibility={this.state.saveFnModalVisibility}
              setSaveFnModalVisibility={(visibility: boolean) => this.setState({ saveFnModalVisibility: visibility })}
              getFunction={() => this.getFunctions(this.props)}
              functionId={this.state.functionId}
              visible={this.state.editable}
              editInitialData={this.state.editInitialData}
              appId={appId}
              versionId={versionId}
              setvisible={(status) => {
                this.setState({ editable: status, editInitialData: {} });
                setTimeout(() => {
                  this.setState({ editvisible: false });
                }, 400);
              }}
              editable={this.state.editable}
              cacheable={this.state.cacheable}
              setCacheable={(cacheable:boolean) => this.setState({ cacheable: cacheable })}
              setExposeEndpoint={(exposeEndpoint:boolean) => this.setState({ exposeEndpoint: exposeEndpoint})}
              exposeEndpoint = {this.state.exposeEndpoint}
              allowedMethods={this.state.allowedMethods}
              setAllowedMethods={(allowedMethods: string[]) => this.setState({ allowedMethods: allowedMethods})}
              apiKeyAuth={this.state.apiKeyAuth}
              setApiKeyAuth={(apiKeyAuth: boolean) => this.setState({ apiKeyAuth: apiKeyAuth})}
            ></FunctionModal>
          )}
          <Modal
            id="deleteFunction"
            dataTestId="delete_function"
            unmountOnCancel={true}
            visible={this.state.deleteVisible}
            title="DELETE FUNCTION"
            onCancel={() => {
              this.setState({
                deleteVisible: false,
                deleteData: {},
              });
            }}
            deleteOptions={{
              type: "Function",
              validateString: this.state.deleteData.name,
            }}
            footer={{
              enable: true,
              okText: "DELETE",
              cancelText: "CANCEL",
              onOk: () => {
                this.deleteFunctions(this.state.deleteData.id);
                this.setState({
                  deleteVisible: false,
                  searchValue: "",
                  filteredData: this?.state?.funcList || []
                });
              },
            }}
          />
        </div>
        :
        <div className="viewWrapper">
          <NoData
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access'
            noButton={true}
          />
        </div>
    );
  }
}

interface FunctionModelProps {
  visible: boolean;
  getFunction: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  versionId: any;
  editInitialData?: any;
  editable?: boolean;
  displayName?:string;
  setDisplayName?: (data: string) => void;
  functionName?:string;
  setFunctionName?: (data: string) => void;
  language?:string;
  setLanguage?: (data:string) => void;
  mode?:string;
  setMode?: (data:string) => void;
  saveFnModalVisibility:boolean;
  setSaveFnModalVisibility: (visibility: boolean) => void;
  functionId:string;
  cacheable?: boolean;
  setCacheable?: (cacheable: boolean) => void;
  setExposeEndpoint?: (exposeEndpoint:boolean) => void;
  exposeEndpoint?:boolean;
  allowedMethods?: string[];
  setAllowedMethods?: (allowedMethods: string[]) => void;
  setApiKeyAuth?: (apiKey: boolean) => void;
  apiKeyAuth?: boolean;
}
let onSubmit: any;
const FunctionModal = ({ 
  visible, getFunction, setvisible, appId, versionId, editInitialData, editable, 
  displayName, setDisplayName, functionName, setFunctionName, language, setLanguage,
  setAllowedMethods, allowedMethods, apiKeyAuth, setApiKeyAuth,
  mode, setMode, saveFnModalVisibility, setSaveFnModalVisibility, functionId, cacheable, setCacheable, setExposeEndpoint, exposeEndpoint }: FunctionModelProps) => {

  const dispatch = useDispatch();
  const updateService = () => {
    const data = {
      name: functionName,
      displayName,
      mode: mode,
      appId: appId,
      versionId: versionId,
      cacheable
    };
    Http.put(`/functions/${functionId}`, data).subscribe(
      (_res) => {
        pushToast({ type: "success", message: "Function updated successfully" });
        getFunction();
        setSaveFnModalVisibility && setSaveFnModalVisibility(false);
      },
      (err) => {
        if (err && err.code === 500) {
          dispatch(pushToast({ type: "error", message: "Request function is not-locked" }));
        } else if (err && err.code === 23505) {
          dispatch(pushToast({ type: "error", message: "Function name already Exists" }));
        } else {
          dispatch(pushToast({ type: "error", message: err && err.message ? err.message : "Function updation failed" }));
        }
        setSaveFnModalVisibility(false);
      }
    );
    setFunctionName && setFunctionName("");
    setDisplayName && setDisplayName("");
    setMode && setMode("");
    setLanguage && setLanguage("");
    setCacheable && setCacheable(false);
    setExposeEndpoint && setExposeEndpoint(false);
    setAllowedMethods && setAllowedMethods([]);
    setApiKeyAuth && setApiKeyAuth(true);
  }

  return (
    <>
      <Modal
        id="createEditFunction"
        dataTestId="create_function"
        title={editInitialData ? "EDIT FUNCTION" : "CREATE FUNCTION"}
        visible={visible}
        onCancel={() => {
          setvisible(false);
          setFunctionName && setFunctionName("");
          setDisplayName && setDisplayName("");
          setMode && setMode("");
          setLanguage && setLanguage("");
          setCacheable && setCacheable(false);
          setExposeEndpoint && setExposeEndpoint(false);
          setAllowedMethods && setAllowedMethods([]);
          setApiKeyAuth && setApiKeyAuth(true)
        }}
        unmountOnCancel={true}
        footer={{
          enable: true,
          okText: editable ? "SAVE" : "CREATE",
          cancelText: "CANCEL",
          onOk: () => {
            if (editInitialData && editInitialData.marketplaceId) {
              setvisible(false);
              setSaveFnModalVisibility && setSaveFnModalVisibility(true)
            } else {
              onSubmit();
            }
          },
        }}
      // mode='EditCreate'
      >
        <Functions
          data-test-id="functions"
          appId={appId}
          getFunction={getFunction}
          editInitialData={editInitialData}
          setvisible={(data) => setvisible(data)}
          onSubmit={(submit) => (onSubmit = submit)}
          editable={editable}
          versionId={versionId}
          displayName={displayName}
          setDisplayName={setDisplayName}
          functionName={functionName}
          setFunctionName={setFunctionName}
          language={language}
          setLanguage={setLanguage}
          mode={mode}
          setMode={setMode}
          cacheable={cacheable}
          exposeEndpoint={exposeEndpoint}
          setCacheable={setCacheable}
          setExposeEndpoint={setExposeEndpoint}
          allowedMethods={allowedMethods}
          setAllowedMethods={setAllowedMethods}
          apiKeyAuth={apiKeyAuth}
          setApiKeyAuth={setApiKeyAuth}
        ></Functions>
      </Modal>
      <Modal
        id="saveEditFunction"
        unmountOnCancel
        visible={saveFnModalVisibility}
        title="SAVE FUNCTION"
        onCancel={() => { 
          setSaveFnModalVisibility(false);
          setFunctionName && setFunctionName("");
          setDisplayName && setDisplayName("");
          setMode && setMode("");
          setLanguage && setLanguage("");
          setCacheable && setCacheable(false);
          setExposeEndpoint && setExposeEndpoint(false)
          setAllowedMethods && setAllowedMethods([]); 
        }}
        footer={{
          enable: true,
          okText: 'SAVE',
          cancelText: 'CANCEL',
          onOk: () => {
            updateService();
          }
        }}
      >
        <div className={style.modalMsg}>
          <p>This function will now be treated as A8 function. Are you sure you want to save?</p>
        </div>
      </Modal>
    </>
  );
};
const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params["appId"]],
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions
  };
};

export default connect(mapStateToProps, { pushToast })(FunctionList);
